/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import qs from "qs";
import { baseApiV2, baseApiV2_1 } from "../../constants/Presets";
import { COLLECTOR_BLOCKED_NO } from "../../constants/Constants";

export function FetchUsers(payload) {
  const url = `${baseApiV2_1}users/list?`;
  const params = [];
  /* istanbul ignore if */
  if (payload.query) {
    const query = encodeURIComponent(payload.query).toString();
    params.push(`q=${query}`);
  }
  const field = payload.field || "modifiedDate";
  params.push(`field=${field}`);
  const status = payload.status || "";
  params.push(`status=${status}`);
  const order = payload.order === "DESC" ? 1 : 0;
  params.push(`order=${order}`);
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const size = payload.size || 0;
  params.push(`size=${size}`);
  const customerCode = payload.companyId || "";
  params.push(`companyId=${customerCode}`);
  if (payload.filters !== null) {
    const filters = encodeURIComponent(JSON.stringify(payload.filters));
    params.push(`filters=${filters}`);
  }
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}
export function FetchAUser() {
  return axios({
    method: "get",
    url: `${baseApiV2}users`,
  });
}
export function FetchAUserDetails(payload) {
  const url = `${baseApiV2_1}users/details?user_id=${payload?.userId}&company_id=${payload?.companyuuid}`;
  return axios.get(url);
}
export function CreateUser(user) {
  const params = {
    name: user.full_name,
    email: user.email,
    roleName: user.roleName,
    isBlocked: user.is_blocked || COLLECTOR_BLOCKED_NO,
    companyUUID: user.company_id,
  };
  return axios({
    method: "post",
    url: `${baseApiV2}users`,
    data: params,
  });
}
export function UpdateUser(user) {
  const url = `${baseApiV2_1}users/${user?.currentCompanyId}`;
  const params = {
    name: user.full_name,
    email: user.email,
    roleName: user.roleName,
    companyUUID: user.company_id,
    isBlocked: user.isBlocked,
    status: user.status,
    userId: user.user_id,
  };
  return axios.patch(url, params);
}
export function EnableUser(id) {
  return axios({
    method: "post",
    data: qs.stringify({
      id,
    }),
    url: `${baseApiV2}users/makeActive/`,
  });
}
export function DisableUser(id) {
  return axios({
    method: "post",
    data: qs.stringify({
      id,
    }),
    url: `${baseApiV2}users/makeDisabled`,
  });
}
export function ChangeUserStatus(payload) {
  const url = `${baseApiV2}user/changeStatus`;
  const params = {
    userId: payload.userId,
    status: payload.status,
  };
  return axios.patch(url, params);
}
export function ResendInvite(email) {
  return axios({
    method: "post",
    url: `${baseApiV2}users/resendInvite?email=${encodeURIComponent(
      email.toString(),
    )}`,
  });
}
export function DeleteUser(payload) {
  if (payload && payload.email) {
    return axios({
      method: "delete",
      url: `${baseApiV2}users?email=${encodeURIComponent(
        payload.email.toString(),
      )}`,
    });
  }
}
export function FetchUserRoles() {
  return axios({
    method: "get",
    url: `${baseApiV2}roles`,
  });
}
